import { Button, Row, Col } from "antd";
import SelectField from "../../../../common/Form/SelectField";
import { FileDoneOutlined } from "@ant-design/icons";
import UploadDocument from "../../../developer/component/uploadDoc";

const MerchantIdentityTab = ({
  formik,
  typeList,
  isSubmitting,
  error,
  toggle,
  onNext,
}) => {
  return (
    <>
      {isSubmitting && (
        <div className="ver-doc-loading-overlay">
          <div className="ver-doc-loading-content">
            <span className="ver-doc-spinner" />
            <p>Envoi des documents en cours...</p>
          </div>
        </div>
      )}
      
      <form onSubmit={formik.handleSubmit}>
        <Row gutter={[16, 16]} justify="center">
          {error && <div className="alert alert-danger">{error}</div>}
          <Col span={20}>
            <SelectField
              label="Type de document"
              name="type"
              nameSelect="le type de document"
              formik={formik}
              options={typeList}
              onChange={(value) => formik.setFieldValue("type", value)}
              error={formik.errors.type}
            />

            {!formik.values.type && (
              <div className="ver-doc-instruction">
                <span className="ver-doc-icon">
                  <FileDoneOutlined />
                </span>
                <p>
                  Merci de sélectionner le type de document et d'uploader les
                  fichiers.
                  <br />
                  Cela ne prend même pas 1 minute !
                </p>
              </div>
            )}

            {formik.values.type && (
              <Row
                gutter={[16, 16]}
                justify={formik.values.type === "CNI" ? "start" : "center"}
              >
                <Col xs={24} sm={24} md={12}>
                  <UploadDocument
                    label={formik.values.type === "CNI" ? "Recto CNI" : "Passport"}
                    name="merchantRecto"
                    value={formik.values.merchantRecto}
                    onChange={(file) => formik.setFieldValue("merchantRecto", file)}
                    colSize={12}
                  />
                </Col>

                {formik.values.type === "CNI" && (
                  <Col xs={24} sm={24} md={12}>
                    <UploadDocument
                      label="Verso CNI"
                      name="merchantVerso"
                      value={formik.values.merchantVerso}
                      onChange={(file) => formik.setFieldValue("merchantVerso", file)}
                      colSize={12}
                    />
                  </Col>
                )}
                
              </Row>
            )}

            <Row gutter={[16, 16]} justify="start" className="mt-3">
              <Col xs={24} sm={24} md={12}>
                <UploadDocument
                  label="RIB ou attestation bancaire"
                  name="RIB"
                  value={formik.values.RIB}
                  onChange={(file) => formik.setFieldValue("RIB", file)}
                  colSize={12}
                />
              </Col>
              <Col xs={24} sm={24} md={12}>
                <UploadDocument
                  label="Justificatif de Domicile"
                  name="Domicile"
                  value={formik.values.Domicile}
                  onChange={(file) => formik.setFieldValue("Domicile", file)}
                  colSize={12}
                />
              </Col>
            </Row>

            <div className="ver-doc-btn-container mt-4">
              <Button
                className="ver-doc-btn ver-doc-btn-cancel"
                onClick={toggle}
              >
                Annuler
              </Button>
              <Button
                loading={isSubmitting}
                className="ver-doc-btn ver-doc-btn-submit"
                type="primary"
                onClick={() => {
                  if (
                    formik.values.merchantRecto &&
                    (formik.values.type !== "CNI" || formik.values.merchantVerso) &&
                    formik.values.RIB &&
                    formik.values.Domicile
                  ) {
                    onNext();
                  }
                }}
                disabled={
                  isSubmitting ||
                  !formik.values.merchantRecto ||
                  (formik.values.type === "CNI" && !formik.values.merchantVerso) ||
                  !formik.values.RIB ||
                  !formik.values.Domicile
                }
              >
                Suivant
              </Button>
            </div>
          </Col>
        </Row>
      </form>
    </>
  );
};

export default MerchantIdentityTab;